import React from "react";
import { func, bool, object } from "prop-types";

import "./hamburger.m.css";

const HamburgerIcon = ({ onMenuToggle, isNavbarOpen, isDesktop, hamburgerStyle }) => (
  <div
    onClick={onMenuToggle}
    styleName={`hamburger ${!isDesktop && isNavbarOpen ? "is-open" : ""}`}
    className="hamburger"
    aria-label="Close"
  >
    <div styleName="line" className="hamburger-line" style={hamburgerStyle} />
    <div styleName="line" className="hamburger-line" style={hamburgerStyle} />
    <div styleName="line" className="hamburger-line" style={hamburgerStyle} />
  </div>
);

export default HamburgerIcon;

HamburgerIcon.propTypes = {
  onMenuToggle: func,
  isNavbarOpen: bool,
  isDesktop: bool,
  hamburgerStyle: object,
};
